"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export type PromotionCodeProvider = {
  code: string;
  imageUrl: string;
};

export const promotionInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: "Promotion Title",
    required: true,
  },
  {
    name: "description",
    type: "string",
    defaultValue: "Promotion Description",
    required: true,
  },
  {
    name: "successMessage",
    type: "string",
    defaultValue: "Success Message",
    required: true,
  },
  {
    name: "errorMessage",
    type: "string",
    defaultValue: "Error Message",
    required: true,
  },
  {
    name: "providers",
    type: "list",
    required: true,
    subFields: [
      {
        name: "code",
        type: "string",
        required: true,
      },
      {
        name: "imageUrl",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
    ],
    defaultValue: [
      {
        code: "7-11",
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fe979595161f740ddb96e8d3c7f5a0333",
      },
      {
        code: "cu",
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fcf07679e0a1544ab82abba13d0e5e22c",
      },
    ],
  },
] as const satisfies Inputs;

export const PromotionComponent: RegisteredComponent = {
  name: "Promotion",
  component: dynamic(async () =>
    withValidation(
      promotionInputs,
      (await import("./Promotion")).Promotion,
      "Promotion"
    )
  ),
  inputs: promotionInputs,
};
